import { createSlice } from "@reduxjs/toolkit";

export const praxis = createSlice({
  name: "praxis",
  initialState: {
    praxisDetails: null,
  },
  reducers: {
    setPraxisDetails: (state, action) => {
      state.praxisDetails = action.payload;
    },
    removePraxisState: (state) => {
      state.praxisDetails = null;
    },
  },
});

export const { setPraxisDetails, removePraxisState } = praxis.actions;

export default praxis.reducer;
